import { checkHttpStatus, getApiHeaders, getApiBaseUrlWithOrg } from '../utils'
import { getErrorAction } from '../utils/actions'
import { getYoutubeTimeValueForEndpoint } from '../utils/resources'

export const CREATE_ACTIVITY_RESOURCE_REQUEST =
  'CREATE_ACTIVITY_RESOURCE_REQUEST'
export const CREATE_ACTIVITY_RESOURCE_SUCCESS =
  'CREATE_ACTIVITY_RESOURCE_SUCCESS'
export const CREATE_ACTIVITY_RESOURCE_FAILURE =
  'CREATE_ACTIVITY_RESOURCE_FAILURE'
export const PATCH_ACTIVITY_RESOURCE_FILE_INFO_SUCCESS =
  'PATCH_ACTIVITY_RESOURCE_FILE_INFO_SUCCESS'
export const EDIT_ACTIVITY_RESOURCE_POSITION_SUCCESS =
  'EDIT_ACTIVITY_RESOURCE_POSITION_SUCCESS'
export const DELETE_ACTIVITY_RESOURCE_SUCCESS =
  'DELETE_ACTIVITY_RESOURCE_SUCCESS'
export const EDIT_ACTIVITY_RESOURCE_SUCCESS = 'EDIT_ACTIVITY_RESOURCE_SUCCESS'
export const EDIT_ACTIVITY_RESOURCE_REQUEST = 'EDIT_ACTIVITY_RESOURCE_REQUEST'
export const EDIT_ACTIVITY_RESOURCE_FAILURE = 'EDIT_ACTIVITY_RESOURCE_FAILURE'
export const REMOVE_ACTIVITY_RESOURCE_FILE_SUCCESS =
  'REMOVE_ACTIVITY_RESOURCE_FILE_SUCCESS'

export function createActivityResourceFailure(error) {
  return getErrorAction(CREATE_ACTIVITY_RESOURCE_FAILURE, error)
}

export function createActivityResourceSuccess(response) {
  return {
    type: CREATE_ACTIVITY_RESOURCE_SUCCESS,
    resource: response
  }
}

export function createActivityResourceRequest() {
  return {
    type: CREATE_ACTIVITY_RESOURCE_REQUEST
  }
}

export function patchActivityResourceFileInfoSuccess(resource) {
  return {
    type: PATCH_ACTIVITY_RESOURCE_FILE_INFO_SUCCESS,
    payload: {
      resource
    }
  }
}

export function editActivityResourceFailure(error: APIError): Action {
  return getErrorAction(EDIT_ACTIVITY_RESOURCE_FAILURE, error)
}

export function editActivityResourceRequest(): Action {
  return {
    type: EDIT_ACTIVITY_RESOURCE_REQUEST
  }
}

export function editActivityResourceSuccess(response: Object): Action {
  return {
    type: EDIT_ACTIVITY_RESOURCE_SUCCESS,
    resource: response
  }
}

export function deleteActivityResourceSuccess(
  activityId: number,
  resourceId: number
): Action {
  return {
    type: DELETE_ACTIVITY_RESOURCE_SUCCESS,
    activityId: activityId,
    resourceId: resourceId
  }
}

export function editActivityResourcePositionSuccess(
  response: Object,
  newIndex: number
): Action {
  return {
    type: EDIT_ACTIVITY_RESOURCE_POSITION_SUCCESS,
    resource: response,
    newIndex: newIndex
  }
}

export function removeActivityResourceFileSuccess(response: Object): Action {
  return {
    type: REMOVE_ACTIVITY_RESOURCE_FILE_SUCCESS,
    resource: response
  }
}

export function patchActivityResourceFileInfo(
  questId,
  activityId,
  resourceId,
  fileProps
) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/activities/${activityId}/resources/${resourceId}/file`
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            resource: {
              resource_file: fileProps.name,
              file_size: fileProps.size,
              content_type: fileProps.type,
              url: null,
              original_file_name: fileProps.original_file_name,
              file_checksum: fileProps.file_checksum
            }
          })
        })
      )
      const json = await response.json()
      dispatch(patchActivityResourceFileInfoSuccess(json))
    } catch (error) {
      throw new Error('patch failed')
    }
  }
}

export function createActivityResource(questId, activity, resourceName) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/activities/${activity.id}/resources`
    dispatch(createActivityResourceRequest())
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            resource: {
              name: resourceName
            }
          })
        })
      )
      const json = await response.json()
      dispatch(createActivityResourceSuccess(json))
    } catch (error) {
      dispatch(createActivityResourceFailure(error))
    }
  }
}

export function editActivityResourcePosition(
  questId: number,
  activityId: number,
  resourceId: number,
  newIndex: number
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/activities/${activityId}/resources/${resourceId}`
    let data = new FormData()
    data.append('resource[sort_order_position]', newIndex.toString())
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: {
            Authorization: `Token token="${state.user.token}"`,
            Accept: 'application/vnd.oefngl.v3'
          },
          body: data
        })
      )
      const json = await response.json()
      dispatch(editActivityResourcePositionSuccess(json, newIndex))
    } catch (error) {
      console.log(error)
    }
  }
}

export function deleteActivityResource(
  questId: number,
  activityId: number,
  resourceId: number,
  isNewResource
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/activities/${activityId}/resources/${resourceId}`
    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'DELETE',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            resource: {
              new_resource: isNewResource
            }
          })
        })
      )
      dispatch(deleteActivityResourceSuccess(activityId, resourceId))
    } catch (error) {
      console.log(error)
    }
  }
}

export function editActivityResource(
  questId: number,
  activityId: number,
  resource: Object,
  isNewResource
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/activities/${activityId}/resources/${resource.id}`
    let body
    dispatch(editActivityResourceRequest())
    if (resource.format === 'file') {
      let data = { resource: {} }
      data.resource.url = null
      data.resource.name = resource.resourceName
      data.resource.description = resource.resourceDescription || null
      data.resource.resource_type = resource.resourceType
      data.resource.start_time = null
      data.resource.end_time = null
      data.resource.new_resource = isNewResource

      if (Object.keys(resource.content_warnings).length === 0) {
        data.resource.clear_content_warnings = true
      } else {
        data.resource.content_warnings = resource.content_warnings
      }

      if (resource.attributionSelection === 'outsideorg') {
        data.resource.license_citation = resource.citation
        data.resource.license_owned_by_organization = false
      } else {
        data.resource.license_citation = null
        data.resource.license_owned_by_organization = true
      }
      body = JSON.stringify(data)
    } else if (resource.format === 'url') {
      body = JSON.stringify({
        resource: {
          description: resource.resourceDescription,
          name: resource.resourceName,
          resource_type: resource.resourceType,
          url: resource.url,
          clear_resource_file: true,
          license_citation: null,
          license_owned_by_organization:
            resource.attributionSelection === 'myorg' ? true : null,
          content_warnings: resource.content_warnings,
          start_time: getYoutubeTimeValueForEndpoint(
            resource.startMinutes,
            resource.startSeconds,
            resource.url,
            resource.resourceType
          ),
          end_time: getYoutubeTimeValueForEndpoint(
            resource.endMinutes,
            resource.endSeconds,
            resource.url,
            resource.resourceType
          ),
          new_resource: isNewResource
        }
      })
    }
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: getApiHeaders(state),
          body
        })
      )
      const json = await response.json()
      dispatch(editActivityResourceSuccess(json))
    } catch (error) {
      dispatch(editActivityResourceFailure(error))
    }
  }
}

export function removeActivityResourceFile(
  questId: number,
  activityId: number,
  resource: Object
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/activities/${activityId}/resources/${resource.id}`
    let data = new FormData()
    data.append('resource[clear_resource_file]', 'true')
    data.append('resource[license_citation]', '')
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: {
            Authorization: `Token token="${state.user.token}"`,
            Accept: 'application/vnd.oefngl.v3'
          },
          body: data
        })
      )
      const json = await response.json()
      dispatch(removeActivityResourceFileSuccess(json))
    } catch (error) {
      console.log(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/resource.js